/*
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2024-02-29 10:48:28
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2024-02-29 11:18:06
 * @FilePath: \jsczt_vue20240117\src\plugins\vant.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)



// WEBPACK FOOTER //
// ./src/plugins/vant.js